export const BrandTagline = () => (
  <section data-testid="brand-tagline" className="rv-tagline border-b border-white/10 bg-[#050505]">
    <div className="mx-auto max-w-[1600px] min-[2200px]:max-w-[2200px] px-3 sm:px-8 py-5 sm:py-7 text-center">
      <h2 data-testid="brand-tagline-motto" className="rv-motto whitespace-nowrap">
        <span className="rv-motto-gold">YOUR CABLE BILL IS OFFICIALLY DEAD • 100% FREE • NO SIGN-UP</span>
        <span className="rv-motto-emoji" aria-hidden="true"> 🍿</span>
      </h2>
      <p data-testid="brand-tagline-attribution" className="rv-attribution whitespace-nowrap">
        Powered by YouTube • Affiliated with JustWatch &amp; THCA
      </p>
    </div>
  </section>
);
